/**
 * Empty State Component
 * Displays an empty state message when there's no data
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { InboxOutlined } from '@mui/icons-material';

interface EmptyStateProps {
  title?: string;
  message?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'No data available',
  message = 'There is no data to display at this time.',
  icon,
  action,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(6),
        textAlign: 'center',
      }}
    >
      {icon || (
        <InboxOutlined
          sx={{
            fontSize: 64,
            color: theme.palette.text.disabled,
            marginBottom: theme.spacing(2),
          }}
        />
      )}
      <Typography
        variant="h6"
        sx={{
          color: theme.palette.text.primary,
          marginBottom: theme.spacing(1),
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          marginBottom: action ? theme.spacing(3) : 0,
        }}
      >
        {message}
      </Typography>
      {action && <Box>{action}</Box>}
    </Box>
  );
};

